import React from 'react';
import "./plugin.css";
import classNames from 'classnames';

export default class ThetaVideoStatusMenu extends React.Component {
  
   getremainingVideoTime() {
     let videoSeconds = this.props.options.remainingVideoSeconds;
     // eslint-disable-next-line
     const videoHour = parseInt(videoSeconds / 3600);
     videoSeconds %= 3600;
    // eslint-disable-next-line
    const videoMin = parseInt(videoSeconds / 60);
     videoSeconds %= 60;
     return videoHour + ':' + videoMin + ':' + videoSeconds;
     
   }
   
    getFileFormat() {
      let fileFormat = this.props.options.fileFormat;
      let fileFormatStr;
      if (parseInt(fileFormat, 10) === 3840) {
        fileFormatStr = '4K';
      } else {
        fileFormatStr = 'Full HD';
      }
      return fileFormatStr;
    }

    render() {
    const { options } = this.props;

    return (

        <div>
        {(() => {
            return (
            <div className={classNames('pluginctrl__header__info')}>
                  <div className={classNames('box--data')}>
                    <div>
                      <p className={classNames('box--data__key')}>残記録時間</p>
                      <p className={classNames('box--data__value--bold')} id="interval_box">{this.getremainingVideoTime()}</p>
                    </div>
                  </div>
                  <div className={classNames('box--data')}>
                    <div>
                      <p className={classNames('box--data__key')}>動画サイズ</p>
                      <p className={classNames('box--data__value--bold')} id="shootcount_box">{this.getFileFormat()}</p>
                    </div>
                  </div>
                  <div className={classNames('box--data')}>
                    <div>
                      <p className={classNames('box--data__key')}>電池残量</p>
                      {Number(options.batteryLevel) < 101 && Number(options.batteryLevel) > 59?
                      <p className={classNames('box--data__value--icon','icon--battery_full')} id="battery_box" ></p>
                      :Number(options.batteryLevel) < 60 && Number(options.batteryLevel) > 29?
                      <p className={classNames('box--data__value--icon','icon--battery_middle')} id="battery_box" ></p>
                      :<p className={classNames('box--data__value--icon','icon--battery_low')} id="battery_box" ></p>
                      }
                      }
                    </div>
                  </div>
            </div>
          );
        })()}
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shooting/ThetaVideoStatusMenu.js